import { useEffect, useState, useMemo } from 'react'
import Loading from '../../components/Loading'
import { api } from '../../config'

/**
 * Agrupa linhas planas { entregadorNome, bairro, total } por entregador (uma passagem).
 */
function groupLinesByEntregador(lines) {
  const order = []
  const byName = new Map()
  for (let i = 0; i < lines.length; i++) {
    const row = lines[i]
    const nome = row.entregadorNome
    if (!byName.has(nome)) {
      byName.set(nome, [])
      order.push(nome)
    }
    byName.get(nome).push({ bairro: row.bairro, total: row.total })
  }
  return order.map((entregadorNome) => {
    const bairros = byName.get(entregadorNome)
    let subtotal = 0
    for (let j = 0; j < bairros.length; j++) subtotal += bairros[j].total
    return { entregadorNome, bairros, subtotal }
  })
}

export default function DeliveriesByBairroEntregadorReports({
  reports,
  handleFind,
  clearReports,
  loading,
  generatePdfDeliveriesByBairroEntregadorReport,
  loja
}) {
  const [initial, setInitial] = useState('')
  const [final, setFinal] = useState('')
  const [loadingPDF, setLoadingPDF] = useState(false)

  const grouped = useMemo(() => (reports && reports.length ? groupLinesByEntregador(reports) : []), [reports])

  const grandTotal = useMemo(() => {
    let t = 0
    for (let i = 0; i < grouped.length; i++) t += grouped[i].subtotal
    return t
  }, [grouped])

  useEffect(() => {
    clearReports()
  }, [])

  function validateDates() {
    if (!initial || !final) {
      alert('Selecione as datas inicial e final')
      return false
    }
    const initialDate = new Date(initial)
    const finalDate = new Date(final)
    if (initialDate > finalDate) {
      alert('A data inicial não pode ser maior que a data final')
      return false
    }
    const diffDays = Math.ceil(Math.abs(finalDate - initialDate) / (1000 * 60 * 60 * 24))
    if (diffDays > 90) {
      alert('Por favor, selecione um período máximo de 90 dias para evitar sobrecarga do sistema')
      return false
    }
    return true
  }

  function handleGenerateReport() {
    if (validateDates()) {
      handleFind({ initial, final })
    }
  }

  function generatePdf() {
    if (!validateDates()) return
    if (!loja) {
      alert('Sessão inválida. Faça login novamente.')
      return
    }

    setLoadingPDF(true)

    const timeout = setTimeout(() => {
      setLoadingPDF(false)
      alert('A geração do relatório está demorando mais que o esperado. Tente novamente com um período menor.')
    }, 60000)

    generatePdfDeliveriesByBairroEntregadorReport({ initial, final }, loja, (report) => {
      clearTimeout(timeout)
      setLoadingPDF(false)
      if (report && report.url) {
        window.open(`${api}/${report.url}`)
      } else {
        alert('Erro ao gerar o relatório. Tente novamente.')
      }
    })
  }

  return (
    <div className="report-section">
      <h3>Entregas por bairro</h3>
      <h2>
        Total de entregas com status <span>Pedido Entregue</span>, por entregador e por bairro. O período é a{' '}
        <span>data de entrega</span> (mesmo critério da coluna &quot;Data Entrega&quot; e dos filtros na tela Entregas).
      </h2>
      <div className="report-search">
        <div className="input-search">
          <label>Do dia</label>
          <input
            type="date"
            min="2021-04-23"
            name="date-initial"
            autoComplete="off"
            onChange={(e) => setInitial(e.target.value)}
          />
        </div>
        <div className="input-search">
          <label>Ao dia</label>
          <input type="date" name="date-final" autoComplete="off" onChange={(e) => setFinal(e.target.value)} />
        </div>
        <button type="button" onClick={handleGenerateReport}>
          Gerar relatório
        </button>
      </div>

      {loading || loadingPDF ? (
        <Loading />
      ) : (
        reports && (
          <div className="report-details deliveries-by-bairro">
            {grouped.length === 0 ? (
              <div className="notFound">Nenhuma entrega concluída no período com entregador atribuído.</div>
            ) : (
              <>
                {grouped.map((block) => (
                  <div className="deliveries-by-bairro-entregador" key={block.entregadorNome}>
                    <h4 className="deliveries-by-bairro-entregador-title">{block.entregadorNome}</h4>
                    <ul className="deliveries-by-bairro-list">
                      {block.bairros.map((item) => (
                        <li key={`${block.entregadorNome}-${item.bairro}`}>
                          <span className="deliveries-by-bairro-nome">{item.bairro}</span>
                          <span className="deliveries-by-bairro-total">
                            {item.total} {item.total === 1 ? 'entrega' : 'entregas'}
                          </span>
                        </li>
                      ))}
                    </ul>
                    <div className="deliveries-by-bairro-entregador-footer">
                      <span className="deliveries-by-bairro-entregador-footer-label">Total do entregador</span>
                      <span className="deliveries-by-bairro-entregador-footer-value">
                        {block.subtotal} {block.subtotal === 1 ? 'entrega' : 'entregas'}
                      </span>
                    </div>
                  </div>
                ))}
                <div className="deliveries-by-bairro-grand totalAmount">
                  <label>Total geral</label>
                  <span>
                    {grandTotal} {grandTotal === 1 ? 'entrega' : 'entregas'}
                  </span>
                </div>
                <button type="button" className="generatePdf" onClick={generatePdf}>
                  Imprimir relatório
                </button>
              </>
            )}
          </div>
        )
      )}
    </div>
  )
}
